import React from 'react';
import { useIntl } from 'react-intl-next';

import { SearchFooter } from '@atlassian/search-dialog';

import { messages } from '../messages';

import { SearchFooterWrapper, FeedbackLinkWrapper, FeedbackLink } from './styled';
import { useUserContext } from '../../../../common/user-context/user-context';
import { AtlassianHomeSearchLink } from '../../../advanced-search-footer/atlassian-home-search-link';
import { ReturnIconWithModifier, AdvancedSearchFooter, type AdvancedSearchFooterProps } from '../../../advanced-search-footer/advanced-search-footer';
import { useTypedAggregatorClient } from '../../../aggregator-client-context/aggregator-client-context';
export interface WithTrelloFooterProps extends AdvancedSearchFooterProps {
	feedbackUrl?: string;
	showAtlassianHomeSearchLink?: boolean;
}

export const TrelloFooter: ({ feedbackUrl, showAtlassianHomeSearchLink, ...rest }: WithTrelloFooterProps) => React.JSX.Element = ({
	feedbackUrl,
	showAtlassianHomeSearchLink,
	...rest
}: WithTrelloFooterProps) => {
	const { formatMessage } = useIntl();
	const { orgId } = useUserContext();
	const aggregatorClient = useTypedAggregatorClient();
	const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
	return (
		<SearchFooterWrapper>
			<AdvancedSearchFooter
				{...rest}
				returnKeyIconComponent={
					showAtlassianHomeSearchLink ? () => <ReturnIconWithModifier /> : undefined
				}
			/>
			{showAtlassianHomeSearchLink && orgId && cloudId && (
				<SearchFooter>
					<AtlassianHomeSearchLink orgId={orgId} cloudId={cloudId} showModifierIcon />
				</SearchFooter>
			)}
			{feedbackUrl && (
				<FeedbackLinkWrapper>
					<FeedbackLink appearance="subtle-link" href={feedbackUrl} target="_blank">
						{formatMessage(messages.trello_feedback_link)}
					</FeedbackLink>
				</FeedbackLinkWrapper>
			)}
		</SearchFooterWrapper>
	);
};
